import { Box, Chip } from '@material-ui/core';
import { useHireTypeStyles } from './stye';

interface ICustomChipForWetandDryHire {
  equipmentData: {
    wet_hire: boolean;
    dry_and_wet_hire: boolean;
  };
  changeHireTypePermission: boolean;
}

function CustomChipForWetandDryHire({
  equipmentData,
  changeHireTypePermission,
}: ICustomChipForWetandDryHire) {
  const classes = useHireTypeStyles();
  const wetHireType = equipmentData?.wet_hire ?? false;
  const bothType = equipmentData?.dry_and_wet_hire && changeHireTypePermission;

  let chipComponent;

  if (bothType) {
    chipComponent = (
      <Box display="flex" alignItems="center" style={{ gap: '5px' }}>
        <Chip
          label="Wet Hire/Dry Hire"
          className={classes.bothHire}
          size="small"
        />
      </Box>
    );
  } else if (wetHireType) {
    chipComponent = (
      <Chip label="Wet Hire" className={classes.wetHire} size="small" />
    );
  } else {
    chipComponent = (
      <Chip label="Dry Hire" className={classes.dryHire} size="small" />
    );
  }

  return <>{chipComponent}</>;
}

export default CustomChipForWetandDryHire;
